export default __webpack_public_path__ + "static/media/arret.ab6f806a.svg";